import { render, staticRenderFns } from "./PublicatorImportDialog.vue?vue&type=template&id=259928ee&scoped=true"
import script from "./PublicatorImportDialog.vue?vue&type=script&lang=js"
export * from "./PublicatorImportDialog.vue?vue&type=script&lang=js"
import style0 from "./PublicatorImportDialog.vue?vue&type=style&index=0&id=259928ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259928ee",
  null
  
)

export default component.exports